export const Plan_followup = 13;
export const Plan_100 = 14;
export const Plan_trainers = 15;

export function isInPlan(login, planId) {
    if (!login.plan) return false;
    if (planId instanceof Array) {
        return planId.includes(login.plan.id);
    }
    return login.plan.id === planId;
}

export function trainerMode(login) {
    return isInPlan(login, Plan_trainers) ? login.meta["trainer-mode"] : false;
}

export function isInPlanOrTrainerMode(login, planId, mode) {
    return isInPlan(login, planId) || trainerMode(login) === mode;
}